import { makeStyles } from '@griffel/react';

import type { GriffelClassNames } from '../../../../util/classNames';

export const useClassNames: () => GriffelClassNames<'container'> = makeStyles({
  container: {
    overflowY: 'hidden',
  },
});
